import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setSent(true); void apiError(err); }
    setBusy(false);
  };

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-4 py-10">
      <div className="rounded-3xl border border-slate-200 bg-white p-7 shadow-sm">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-soft text-brand"><CheckCircle2 className="h-7 w-7" /></div>
            <h1 className="font-head text-xl font-black text-slate-900">Check your email</h1>
            <p className="mt-2 text-sm text-slate-500">If <b>{email}</b> is registered, we've sent a link to reset your password. The link expires in 1 hour.</p>
            <Link to="/login" className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-brand"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-head text-2xl font-black text-slate-900">Forgot password?</h1>
            <p className="mt-1 text-sm text-slate-500">Enter your account email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-5 space-y-3">
              <div className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 focus-within:border-brand">
                <Mail className="h-4 w-4 text-slate-400" />
                <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="you@email.com"
                  data-testid="forgot-email" className="w-full bg-transparent py-2.5 text-sm outline-none" />
              </div>
              <button type="submit" disabled={busy} data-testid="forgot-submit"
                className="w-full rounded-xl bg-brand py-2.5 text-sm font-bold text-white hover:bg-brand-deep disabled:opacity-60">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <Link to="/login" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-brand"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
